var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForumDetailsSmiling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.94,
    height: 21.94,
    viewBox: "0 0 21.94 21.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smiling-emoticon-square-face",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M18.731,3.21a10.975,10.975,0,1,0,0,15.52A10.987,10.987,0,0,0,18.731,3.21Zm-1.2,14.323a9.282,9.282,0,1,1,0-13.127A9.293,9.293,0,0,1,17.533,17.533ZM6.876,8A1.283,1.283,0,1,1,8.159,9.283,1.283,1.283,0,0,1,6.876,8Zm5.816,0a1.283,1.283,0,1,1,1.283,1.283A1.283,1.283,0,0,1,12.693,8Zm3.033,5.254a5.121,5.121,0,0,1-4.743,3.026,5.086,5.086,0,0,1-4.771-3.042.621.621,0,1,1,1.146-.476,3.85,3.85,0,0,0,3.625,2.276,3.881,3.881,0,0,0,3.6-2.278.621.621,0,0,1,1.139.493Z",
    transform: "translate(0 0)",
    fill: "#40eefe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumDetailsSmiling);
export default __webpack_public_path__ + "static/media/forum-details-smiling.d0914850de2c758385e2afd5ac843711.svg";
export { ForwardRef as ReactComponent };